import type { IPricingComparisonFeatureForPlan, IPricingComparisonGroup } from '../types';

import { CheckIcon, MinusIcon } from '@shopify/polaris-icons';
import { IPlanToolTipKey, IPlanKey } from '../types';

const SUPPORT_FEATURE: IPricingComparisonFeatureForPlan = {
  iconProps: { source: CheckIcon, tone: 'primary' },
};
const UN_SUPPORT_FEATURE: IPricingComparisonFeatureForPlan = {
  iconProps: { source: MinusIcon, tone: 'subdued' },
};

const SUPPORT_ALL_PLAN = {
  [IPlanKey.PAGE_OPT]: SUPPORT_FEATURE,
  [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
};

export const INSIGHT_FEATURES: IPricingComparisonGroup = {
  title: 'Insight',
  features: [
    {
      title: 'Analytics for single pages',
      plansDetail: {
        [IPlanKey.PAGE_OPT]: { descriptions: [{ content: '10 pages' }] },
        [IPlanKey.FUNNEL_OPT]: { descriptions: [{ content: 'Unlimited' }] },
      },
    },
    {
      title: 'Journey analysis',
      plansDetail: {
        [IPlanKey.PAGE_OPT]: UN_SUPPORT_FEATURE,
        [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
      },
    },
    {
      title: 'Heatmap',
      badgeProps: { tone: 'info', children: 'Beta' },
      plansDetail: {
        [IPlanKey.PAGE_OPT]: UN_SUPPORT_FEATURE,
        [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
      },
    },
    {
      title: 'Funnel Analysis',
      badgeProps: { tone: 'info', children: 'Upcoming' },
      plansDetail: {
        [IPlanKey.PAGE_OPT]: UN_SUPPORT_FEATURE,
        [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
      },
    },
  ],
};

export const EXPERIMENTS_FEATURES: IPricingComparisonGroup = {
  title: 'Experiments',
  features: [
    {
      title: 'Template testing',
      tooltipKey: IPlanToolTipKey.TEMPLATE_TESTING,
      plansDetail: {
        [IPlanKey.PAGE_OPT]: { descriptions: [{ content: '10 live experiments' }] },
        [IPlanKey.FUNNEL_OPT]: { descriptions: [{ content: 'Unlimited' }] },
      },
      children: [
        { title: 'Test Shopify vs. GemPages templates', plansDetail: SUPPORT_ALL_PLAN },
        { title: 'Test text for headline or key message', plansDetail: SUPPORT_ALL_PLAN },
        { title: 'Test layout & structure', plansDetail: SUPPORT_ALL_PLAN },
        { title: 'Test every element, component & section', plansDetail: SUPPORT_ALL_PLAN },
        { title: 'Test CTA & button variations', plansDetail: SUPPORT_ALL_PLAN },
        { title: 'Test different page types', plansDetail: SUPPORT_ALL_PLAN },
      ],
    },
    {
      title: 'Product price testing',
      tooltipKey: IPlanToolTipKey.PRODUCT_PRICE_TESTING,
      plansDetail: SUPPORT_ALL_PLAN,
      children: [
        { title: 'Test price with no Shopify Plus required', plansDetail: SUPPORT_ALL_PLAN },
        { title: 'Test subscription price', plansDetail: SUPPORT_ALL_PLAN },
      ],
    },
    {
      title: 'Multipage testing',
      tooltipKey: IPlanToolTipKey.MULTIPAGE_TESTING,
      plansDetail: {
        [IPlanKey.PAGE_OPT]: UN_SUPPORT_FEATURE,
        [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
      },
      children: [
        {
          title: 'Test multiple templates',
          plansDetail: {
            [IPlanKey.PAGE_OPT]: UN_SUPPORT_FEATURE,
            [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
          },
        },
        {
          title: 'Test full funnel',
          plansDetail: {
            [IPlanKey.PAGE_OPT]: UN_SUPPORT_FEATURE,
            [IPlanKey.FUNNEL_OPT]: SUPPORT_FEATURE,
          },
        },
      ],
    },
    { title: 'Advanced targeting: audiences, devices & sources', plansDetail: SUPPORT_ALL_PLAN },
  ],
};

export const SUPPORT_FEATURES: IPricingComparisonGroup = {
  title: 'Support',
  features: [
    {
      title: 'Chat support',
      plansDetail: {
        [IPlanKey.PAGE_OPT]: {
          descriptions: [{ content: '24/7 Support' }, { content: 'Priority Support' }],
        },
        [IPlanKey.FUNNEL_OPT]: {
          descriptions: [{ content: '24/7 Support' }, { content: 'Priority Support' }],
        },
      },
    },
  ],
};

export const FEATURE_GROUPS: IPricingComparisonGroup[] = [
  EXPERIMENTS_FEATURES,
  INSIGHT_FEATURES,
  SUPPORT_FEATURES,
];
